import { IdLabel } from "../../../../components/IdLabel/index.js";
import { useLocationLogEntry } from "../../hooks/useLocationLogEntry.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntryTitle.tsx
function LocationLogEntryTitle({ id, showId }) {
	const { data } = useLocationLogEntry({ entryId: id || "" }, { cacheStrategy: "cache-only" });
	if (data?.entry) return /* @__PURE__ */ jsxs("span", { children: [data.entry.title, showId && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx(IdLabel, {
		className: "text-color-subtle font-medium",
		idLabel: data.entry.idLabel
	})] })] });
	return null;
}
//#endregion
export { LocationLogEntryTitle };

//# sourceMappingURL=LocationLogEntryTitle.js.map